/* istanbul ignore file */
/**
 * Created by sswaminathan on 12/07/22
 * File: TenancyService
 * Project: OneApp Activation
 * © Palo Alto Networks
 */

import axios, { AxiosRequestConfig } from 'axios'
import { getVarValue } from '../../common/utils/Sparky'
import { getTsgToken, getFrameworkServiceUrl } from '@sparky/framework'



/**
 *
 * @type {null}
 */
const TENANT_URL_KEY = 'tenant_base_url'
const TENANCY_SERVICE_URL_KEY = 'tenancy_service'
const TenancyAPI = axios.create({
  baseURL: getFrameworkServiceUrl(TENANCY_SERVICE_URL_KEY) || getVarValue(TENANT_URL_KEY) || undefined,
  timeout: 300 * 1000,
})
export type AxiosRequestConfigWithTsg = AxiosRequestConfig & {
  tsg_id?: string
}
TenancyAPI.interceptors.request.use(async (config: AxiosRequestConfigWithTsg) => {
  const token = await getTsgToken(config?.tsg_id)
  config.headers = { ...config.headers, 'Authorization': `Bearer ${token}` }
  return config
}, error => {
  return Promise.reject(error)
})

TenancyAPI.interceptors.response.use((response) => response, (error) => {
  if (error?.response?.status === 400) {
    throw Object.assign({ status: error?.response?.status, error: error?.response?.data })
    // throw new Error(error.response?.data?.message || error.response?.data?.msg || error.message)
  }
  throw new Error(error.response?.data?.message || error.response?.data?.msg || error.message)
})

/**
 *
 * @type {{init: TenancyService.init, listTenant: {post: (function(*=): *), get: (function(): *), delete: (function(*): *|Error), put: (function(*, *=): *|Error)}}}
 */
const TenancyService = {
  createTenant: {
    post: async (data: any, tsg_id: string) => {
      const axiosObject: AxiosRequestConfigWithTsg = { tsg_id }
      return TenancyAPI.post('/tenant_service_groups', data, { ...axiosObject })
    }
  },
  listTenant: {
    put: async (data: any, tsg_id: string) => {
      return TenancyAPI.put(`/tenant_service_groups/${tsg_id}`, data, { tsg_id } as AxiosRequestConfigWithTsg)
    }
  }
}

export default TenancyService

